<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [maximizable]="false"
  styleClass="circle-credit-modal"
  (onHide)="onModalHide()"
  (onShow)="onModalShow()">
  
  <!-- Header del Modal -->
  <ng-template pTemplate="header">
    <div class="modal-header-content">
      <div class="header-info">
        <h2 class="modal-title">
          <i class="pi pi-chart-line"></i>
          Círculo de Crédito - {{ entityType === 'Física' ? 'Persona Física' : 'Persona Moral' }}
        </h2>
        <p class="modal-subtitle">{{ getTabTitle() }}</p>
      </div>
      <div class="tab-navigation">
        <p-button 
          *ngFor="let tab of tabsConfig; let i = index; trackBy: trackByTabKey"
          [icon]="tab.icon"
          [label]="tab.label"
          (click)="onTabDebugClick($event, tab.key)"
          [styleClass]="'tab-btn ' + (activeTab === tab.key ? 'tab-active' : 'tab-inactive')"
          [text]="true">
        </p-button>
      </div>
    </div>
  </ng-template>

  <!-- Contenido del Modal -->
  <div class="modal-content" [formGroup]="formGroup">
    
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-overlay">
      <p-progressSpinner></p-progressSpinner>
      <p>Guardando información...</p>
    </div>

    <!-- Pestaña: Encabezado -->
    <div *ngIf="activeTab === 'header'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-info-circle"></i> Encabezado</h3>
          <p>Información del otorgante y configuración del reporte</p>
        </div>
        <div class="card-content" formGroupName="header">
          
          <!-- CAMPOS PARA PERSONA FÍSICA -->
          <div *ngIf="entityType === 'Física'" class="form-grid">
            <div class="form-field">
              <label for="grantorKey">Clave Otorgante *</label>
              <input 
                pInputText 
                id="grantorKey" 
                formControlName="grantorKey"
                placeholder="Clave del otorgante"
                class="form-control">
              <small *ngIf="formGroup.get('header.grantorKey')?.invalid && formGroup.get('header.grantorKey')?.touched" 
                     class="error-message">
                La clave del otorgante es requerida
              </small>
            </div>
            
            <div class="form-field">
              <label for="grantorName">Nombre Otorgante</label>
              <input 
                pInputText 
                id="grantorName" 
                formControlName="grantorName"
                placeholder="Nombre del otorgante"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="mediaIdentifier">Identificador de Medio</label>
              <input 
                pInputText 
                id="mediaIdentifier" 
                formControlName="mediaIdentifier"
                placeholder="Identificador de medio"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="extractionDate">Fecha Extracción</label>
              <p-calendar 
                id="extractionDate"
                formControlName="extractionDate"
                placeholder="Seleccione la fecha"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="grantorNote">Nota Otorgante</label>
              <input 
                pInputText 
                id="grantorNote" 
                formControlName="grantorNote"
                placeholder="Nota del otorgante"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="version">Versión</label>
              <input 
                pInputText 
                id="version" 
                formControlName="version"
                placeholder="Versión del reporte"
                class="form-control">
            </div>
          </div>

          <!-- CAMPOS PARA PERSONA MORAL -->
          <div *ngIf="entityType === 'Moral'" class="form-grid">
            <div class="form-field">
              <label for="grantor">Otorgante *</label>
              <input 
                pInputText 
                id="grantor" 
                formControlName="grantor"
                placeholder="Otorgante"
                class="form-control">
              <small *ngIf="formGroup.get('header.grantor')?.invalid && formGroup.get('header.grantor')?.touched" 
                     class="error-message">
                El otorgante es requerido
              </small>
            </div>
            
            <div class="form-field">
              <label for="previousGrantor">Otorgante Anterior</label>
              <input 
                pInputText 
                id="previousGrantor" 
                formControlName="previousGrantor"
                placeholder="Otorgante anterior"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="grantorNamePM">Nombre Otorgante</label>
              <input 
                pInputText 
                id="grantorNamePM" 
                formControlName="grantorName"
                placeholder="Nombre del otorgante"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="institution">Institución</label>
              <input 
                pInputText 
                id="institution" 
                formControlName="institution"
                placeholder="Institución"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="format">Formato</label>
              <input 
                pInputText 
                id="format" 
                formControlName="format"
                placeholder="Formato"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="generationDate">Fecha Generación</label>
              <p-calendar 
                id="generationDate"
                formControlName="generationDate"
                placeholder="Seleccione la fecha"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="reportingPeriod">Periodo que Reporta</label>
              <input 
                pInputText 
                id="reportingPeriod" 
                formControlName="reportingPeriod"
                placeholder="Periodo que reporta"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="versionPM">Versión</label>
              <input 
                pInputText 
                id="versionPM" 
                formControlName="version"
                placeholder="Versión del reporte"
                class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Datos Personales (Solo PF) -->
    <div *ngIf="activeTab === 'personalData' && entityType === 'Física'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-user"></i> Datos Personales</h3>
          <p>Información personal del solicitante</p>
        </div>
        <div class="card-content" formGroupName="personalData">
          <div class="form-grid">
            <div class="form-field">
              <label for="givenNames">Nombre(s)</label>
              <input 
                pInputText 
                id="givenNames" 
                formControlName="givenNames"
                placeholder="Nombre(s)"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="lastNameFather">Apellido Paterno</label>
              <input 
                pInputText 
                id="lastNameFather" 
                formControlName="lastNameFather"
                placeholder="Apellido paterno"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="lastNameMother">Apellido Materno</label>
              <input 
                pInputText 
                id="lastNameMother" 
                formControlName="lastNameMother"
                placeholder="Apellido materno"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="additionalLastName">Apellido Adicional</label>
              <input 
                pInputText 
                id="additionalLastName" 
                formControlName="additionalLastName"
                placeholder="Apellido adicional"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="rfc">RFC</label>
              <input 
                pInputText 
                id="rfc" 
                formControlName="rfc"
                placeholder="RFC"
                maxlength="13"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="curp">CURP</label>
              <input 
                pInputText 
                id="curp" 
                formControlName="curp"
                placeholder="CURP"
                maxlength="18"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="birthDate">Fecha de Nacimiento</label>
              <p-calendar 
                id="birthDate"
                formControlName="birthDate"
                placeholder="Fecha de nacimiento"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="sex">Sexo</label>
              <p-dropdown 
                id="sex"
                formControlName="sex"
                [options]="[
                  {label: 'Masculino', value: 'M'},
                  {label: 'Femenino', value: 'F'}
                ]"
                placeholder="Seleccione el sexo">
              </p-dropdown>
            </div>
            
            <div class="form-field">
              <label for="nationality">Nacionalidad</label>
              <input 
                pInputText 
                id="nationality" 
                formControlName="nationality"
                placeholder="Nacionalidad"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="socialSecurityNumber">Número de Seguridad Social</label>
              <input 
                pInputText 
                id="socialSecurityNumber" 
                formControlName="socialSecurityNumber"
                placeholder="Número de seguridad social"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="residence">Residencia</label>
              <input 
                pInputText 
                id="residence" 
                formControlName="residence"
                placeholder="Residencia"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="driverLicenseNumber">Número de Licencia de Conducir</label>
              <input 
                pInputText 
                id="driverLicenseNumber" 
                formControlName="driverLicenseNumber"
                placeholder="Número de licencia"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="maritalStatus">Estado Civil</label>
              <p-dropdown 
                id="maritalStatus"
                formControlName="maritalStatus"
                [options]="[
                  {label: 'Soltero(a)', value: 'S'},
                  {label: 'Casado(a)', value: 'C'},
                  {label: 'Divorciado(a)', value: 'D'},
                  {label: 'Viudo(a)', value: 'V'},
                  {label: 'Unión Libre', value: 'U'}
                ]"
                placeholder="Seleccione estado civil">
              </p-dropdown>
            </div>
            
            <div class="form-field">
              <label for="voterKeyIFE">Clave de Elector IFE</label>
              <input 
                pInputText 
                id="voterKeyIFE" 
                formControlName="voterKeyIFE"
                placeholder="Clave de elector"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="dependentsNumber">Número de Dependientes</label>
              <p-inputNumber 
                id="dependentsNumber" 
                formControlName="dependentsNumber"
                placeholder="Número de dependientes"
                [min]="0"
                [max]="99"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="personType">Tipo de Persona</label>
              <input 
                pInputText 
                id="personType" 
                formControlName="personType"
                placeholder="Tipo de persona"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="deathIndicator">Indicador de Defunción</label>
              <p-dropdown 
                id="deathIndicator"
                formControlName="deathIndicator"
                [options]="[
                  {label: 'No', value: false},
                  {label: 'Sí', value: true}
                ]"
                placeholder="Seleccione">
              </p-dropdown>
            </div>
            
            <div class="form-field">
              <label for="deathDate">Fecha de Defunción</label>
              <p-calendar 
                id="deathDate"
                formControlName="deathDate"
                placeholder="Fecha de defunción"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Datos de la Empresa (Solo PM) -->
    <div *ngIf="activeTab === 'company' && entityType === 'Moral'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-building"></i> Datos de la Empresa</h3>
          <p>Información de la empresa o persona moral según el backend schema</p>
        </div>
        <div class="card-content" formGroupName="company">
          <div class="form-grid">
            <!-- Información Básica -->
            <div class="form-field">
              <label for="companyName">Razón Social *</label>
              <input 
                pInputText 
                id="companyName" 
                formControlName="companyName"
                placeholder="Razón social de la empresa"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="rfc">RFC *</label>
              <input 
                pInputText 
                id="rfc" 
                formControlName="rfc"
                placeholder="RFC de la empresa"
                maxlength="13"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="curp">CURP</label>
              <input 
                pInputText 
                id="curp" 
                formControlName="curp"
                placeholder="CURP"
                class="form-control">
            </div>
            
            <!-- Nombres Personales (para representante legal) -->
            <div class="form-field">
              <label for="firstName">Nombre 1</label>
              <input 
                pInputText 
                id="firstName" 
                formControlName="firstName"
                placeholder="Primer nombre"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="middleName">Nombre 2</label>
              <input 
                pInputText 
                id="middleName" 
                formControlName="middleName"
                placeholder="Segundo nombre"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="lastNameFather">Apellido Paterno</label>
              <input 
                pInputText 
                id="lastNameFather" 
                formControlName="lastNameFather"
                placeholder="Apellido paterno"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="lastNameMother">Apellido Materno</label>
              <input 
                pInputText 
                id="lastNameMother" 
                formControlName="lastNameMother"
                placeholder="Apellido materno"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="nationality">Nacionalidad</label>
              <input 
                pInputText 
                id="nationality" 
                formControlName="nationality"
                placeholder="Nacionalidad"
                class="form-control">
            </div>
            
            <!-- Información Crediticia -->
            <div class="form-field">
              <label for="portfolioRating">Calificación Cartera</label>
              <input 
                pInputText 
                id="portfolioRating" 
                formControlName="portfolioRating"
                placeholder="Calificación de cartera"
                class="form-control">
            </div>
            
            <!-- Claves Banxico -->
            <div class="form-field">
              <label for="banxicoKey1">Clave Banxico 1 / SCIAN</label>
              <input 
                pInputText 
                id="banxicoKey1" 
                formControlName="banxicoKey1"
                placeholder="Clave Banxico 1"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="banxicoKey2">Clave Banxico 2 / SCIAN</label>
              <input 
                pInputText 
                id="banxicoKey2" 
                formControlName="banxicoKey2"
                placeholder="Clave Banxico 2"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="banxicoKey3">Clave Banxico 3 / SCIAN</label>
              <input 
                pInputText 
                id="banxicoKey3" 
                formControlName="banxicoKey3"
                placeholder="Clave Banxico 3"
                class="form-control">
            </div>
            
            <!-- Dirección -->
            <div class="form-field full-width">
              <label for="address1">Dirección 1</label>
              <input 
                pInputText 
                id="address1" 
                formControlName="address1"
                placeholder="Dirección principal"
                class="form-control">
            </div>
            
            <div class="form-field full-width">
              <label for="address2">Dirección 2</label>
              <input 
                pInputText 
                id="address2" 
                formControlName="address2"
                placeholder="Dirección secundaria"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="neighborhood">Colonia</label>
              <input 
                pInputText 
                id="neighborhood" 
                formControlName="neighborhood"
                placeholder="Colonia"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="municipality">Deleg/Mun</label>
              <input 
                pInputText 
                id="municipality" 
                formControlName="municipality"
                placeholder="Delegación/Municipio"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="city">Ciudad</label>
              <input 
                pInputText 
                id="city" 
                formControlName="city"
                placeholder="Ciudad"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="state">Estado</label>
              <input 
                pInputText 
                id="state" 
                formControlName="state"
                placeholder="Estado"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="postalCode">CP</label>
              <input 
                pInputText 
                id="postalCode" 
                formControlName="postalCode"
                placeholder="Código postal"
                class="form-control">
            </div>
            
            <!-- Contacto -->
            <div class="form-field">
              <label for="phone">Teléfono</label>
              <input 
                pInputText 
                id="phone" 
                formControlName="phone"
                placeholder="Número de teléfono"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="extension">Extensión</label>
              <input 
                pInputText 
                id="extension" 
                formControlName="extension"
                placeholder="Extensión"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="fax">Fax</label>
              <input 
                pInputText 
                id="fax" 
                formControlName="fax"
                placeholder="Número de fax"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="mobilePhone">Teléfono Móvil</label>
              <input 
                pInputText 
                id="mobilePhone" 
                formControlName="mobilePhone"
                placeholder="Teléfono móvil"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="email">Correo Electrónico</label>
              <input 
                pInputText 
                id="email" 
                formControlName="email"
                placeholder="Correo electrónico"
                type="email"
                class="form-control">
            </div>
            
            <!-- Información Adicional -->
            <div class="form-field">
              <label for="clientType">Tipo Cliente</label>
              <input 
                pInputText 
                id="clientType" 
                formControlName="clientType"
                placeholder="Tipo de cliente"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="foreignState">Edo Extranjero</label>
              <input 
                pInputText 
                id="foreignState" 
                formControlName="foreignState"
                placeholder="Estado extranjero"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="country">País</label>
              <input 
                pInputText 
                id="country" 
                formControlName="country"
                placeholder="País"
                class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Accionista (Solo PM) -->
    <div *ngIf="activeTab === 'shareholder' && entityType === 'Moral'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-users"></i> Accionista</h3>
          <p>Información del accionista principal</p>
        </div>
        <div class="card-content" formGroupName="shareholder">
          <div class="form-grid">
            <div class="form-field">
              <label for="shareholderRfc">RFC</label>
              <input 
                pInputText 
                id="shareholderRfc" 
                formControlName="rfc"
                placeholder="RFC del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderCurp">CURP</label>
              <input 
                pInputText 
                id="shareholderCurp" 
                formControlName="curp"
                placeholder="CURP del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderCompanyName">Nombre de Empresa</label>
              <input 
                pInputText 
                id="shareholderCompanyName" 
                formControlName="companyName"
                placeholder="Nombre de la empresa"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderFirstName">Nombre</label>
              <input 
                pInputText 
                id="shareholderFirstName" 
                formControlName="firstName"
                placeholder="Nombre del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderMiddleName">Segundo Nombre</label>
              <input 
                pInputText 
                id="shareholderMiddleName" 
                formControlName="middleName"
                placeholder="Segundo nombre"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderLastNameFather">Apellido Paterno</label>
              <input 
                pInputText 
                id="shareholderLastNameFather" 
                formControlName="lastNameFatherShareholder"
                placeholder="Apellido paterno"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderLastNameMother">Apellido Materno</label>
              <input 
                pInputText 
                id="shareholderLastNameMother" 
                formControlName="lastNameMotherShareholder"
                placeholder="Apellido materno"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderPercentage">Porcentaje de Participación</label>
              <p-inputNumber 
                id="shareholderPercentage"
                formControlName="percentage"
                [min]="0" 
                [max]="100"
                suffix="%"
                placeholder="Porcentaje">
              </p-inputNumber>
            </div>

            <!-- Información de Dirección del Accionista -->
            <div class="form-field full-width">
              <label for="shareholderAddress1">Dirección 1</label>
              <input 
                pInputText 
                id="shareholderAddress1" 
                formControlName="address1"
                placeholder="Dirección principal del accionista"
                class="form-control">
            </div>
            
            <div class="form-field full-width">
              <label for="shareholderAddress2">Dirección 2</label>
              <input 
                pInputText 
                id="shareholderAddress2" 
                formControlName="address2"
                placeholder="Dirección secundaria del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderNeighborhood">Colonia</label>
              <input 
                pInputText 
                id="shareholderNeighborhood" 
                formControlName="neighborhood"
                placeholder="Colonia del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderMunicipality">Deleg/Mun</label>
              <input 
                pInputText 
                id="shareholderMunicipality" 
                formControlName="municipality"
                placeholder="Delegación/Municipio del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderCity">Ciudad</label>
              <input 
                pInputText 
                id="shareholderCity" 
                formControlName="city"
                placeholder="Ciudad del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderState">Estado</label>
              <input 
                pInputText 
                id="shareholderState" 
                formControlName="state"
                placeholder="Estado del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderPostalCode">CP</label>
              <input 
                pInputText 
                id="shareholderPostalCode" 
                formControlName="postalCode"
                placeholder="Código postal del accionista"
                class="form-control">
            </div>

            <!-- Información de Contacto del Accionista -->
            <div class="form-field">
              <label for="shareholderPhone">Teléfono</label>
              <input 
                pInputText 
                id="shareholderPhone" 
                formControlName="phone"
                placeholder="Teléfono del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderExtension">Extensión</label>
              <input 
                pInputText 
                id="shareholderExtension" 
                formControlName="extension"
                placeholder="Extensión del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderFax">Fax</label>
              <input 
                pInputText 
                id="shareholderFax" 
                formControlName="fax"
                placeholder="Fax del accionista"
                class="form-control">
            </div>

            <!-- Información Adicional del Accionista -->
            <div class="form-field">
              <label for="shareholderClientType">Tipo Cliente</label>
              <input 
                pInputText 
                id="shareholderClientType" 
                formControlName="clientType"
                placeholder="Tipo de cliente del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderForeignState">Edo Extranjero</label>
              <input 
                pInputText 
                id="shareholderForeignState" 
                formControlName="foreignState"
                placeholder="Estado extranjero del accionista"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="shareholderCountry">País</label>
              <input 
                pInputText 
                id="shareholderCountry" 
                formControlName="country"
                placeholder="País del accionista"
                class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Aval (Solo PM) -->
    <div *ngIf="activeTab === 'guarantor' && entityType === 'Moral'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-shield"></i> Aval</h3>
          <p>Información del aval o garante</p>
        </div>
        <div class="card-content" formGroupName="guarantor">
          <div class="form-grid">
            <div class="form-field">
              <label for="guarantorRfc">RFC</label>
              <input 
                pInputText 
                id="guarantorRfc" 
                formControlName="rfc"
                placeholder="RFC del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorCurp">CURP</label>
              <input 
                pInputText 
                id="guarantorCurp" 
                formControlName="curp"
                placeholder="CURP del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorCompanyName">Nombre de Empresa</label>
              <input 
                pInputText 
                id="guarantorCompanyName" 
                formControlName="companyName"
                placeholder="Nombre de la empresa"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorFirstName">Nombre</label>
              <input 
                pInputText 
                id="guarantorFirstName" 
                formControlName="firstName"
                placeholder="Nombre del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorMiddleName">Segundo Nombre</label>
              <input 
                pInputText 
                id="guarantorMiddleName" 
                formControlName="middleName"
                placeholder="Segundo nombre"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorLastNameFather">Apellido Paterno</label>
              <input 
                pInputText 
                id="guarantorLastNameFather" 
                formControlName="lastNameFatherGuarantor"
                placeholder="Apellido paterno"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorLastNameMother">Apellido Materno</label>
              <input 
                pInputText 
                id="guarantorLastNameMother" 
                formControlName="lastNameMotherGuarantor"
                placeholder="Apellido materno"
                class="form-control">
            </div>

            <!-- Información de Dirección del Aval -->
            <div class="form-field full-width">
              <label for="guarantorAddress1">Dirección 1</label>
              <input 
                pInputText 
                id="guarantorAddress1" 
                formControlName="address1"
                placeholder="Dirección principal del aval"
                class="form-control">
            </div>
            
            <div class="form-field full-width">
              <label for="guarantorAddress2">Dirección 2</label>
              <input 
                pInputText 
                id="guarantorAddress2" 
                formControlName="address2"
                placeholder="Dirección secundaria del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorNeighborhood">Colonia</label>
              <input 
                pInputText 
                id="guarantorNeighborhood" 
                formControlName="neighborhood"
                placeholder="Colonia del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorMunicipality">Deleg/Mun</label>
              <input 
                pInputText 
                id="guarantorMunicipality" 
                formControlName="municipality"
                placeholder="Delegación/Municipio del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorCity">Ciudad</label>
              <input 
                pInputText 
                id="guarantorCity" 
                formControlName="city"
                placeholder="Ciudad del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorState">Estado</label>
              <input 
                pInputText 
                id="guarantorState" 
                formControlName="state"
                placeholder="Estado del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorPostalCode">CP</label>
              <input 
                pInputText 
                id="guarantorPostalCode" 
                formControlName="postalCode"
                placeholder="Código postal del aval"
                class="form-control">
            </div>

            <!-- Información de Contacto del Aval -->
            <div class="form-field">
              <label for="guarantorPhone">Teléfono</label>
              <input 
                pInputText 
                id="guarantorPhone" 
                formControlName="phone"
                placeholder="Teléfono del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorExtension">Extensión</label>
              <input 
                pInputText 
                id="guarantorExtension" 
                formControlName="extension"
                placeholder="Extensión del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorFax">Fax</label>
              <input 
                pInputText 
                id="guarantorFax" 
                formControlName="fax"
                placeholder="Fax del aval"
                class="form-control">
            </div>

            <!-- Información Adicional del Aval -->
            <div class="form-field">
              <label for="guarantorClientType">Tipo Cliente</label>
              <input 
                pInputText 
                id="guarantorClientType" 
                formControlName="clientType"
                placeholder="Tipo de cliente del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorForeignState">Edo Extranjero</label>
              <input 
                pInputText 
                id="guarantorForeignState" 
                formControlName="foreignState"
                placeholder="Estado extranjero del aval"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="guarantorCountry">País</label>
              <input 
                pInputText 
                id="guarantorCountry" 
                formControlName="country"
                placeholder="País del aval"
                class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Domicilio -->
    <div *ngIf="activeTab === 'address'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-map-marker"></i> Domicilio</h3>
          <p>Información de domicilio del solicitante</p>
        </div>
        <div class="card-content" formGroupName="address">
          <div class="form-grid">
            <div class="form-field full-width">
              <label for="address">Dirección</label>
              <input 
                pInputText 
                id="address" 
                formControlName="address"
                placeholder="Calle, número, etc."
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="neighborhood">Colonia/Población</label>
              <input 
                pInputText 
                id="neighborhood" 
                formControlName="neighborhood"
                placeholder="Colonia o población"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="municipality">Delegación/Municipio</label>
              <input 
                pInputText 
                id="municipality" 
                formControlName="municipality"
                placeholder="Delegación o municipio"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="city">Ciudad</label>
              <input 
                pInputText 
                id="city" 
                formControlName="city"
                placeholder="Ciudad"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="state">Estado</label>
              <input 
                pInputText 
                id="state" 
                formControlName="state"
                placeholder="Estado"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="postalCode">Código Postal</label>
              <input 
                pInputText 
                id="postalCode" 
                formControlName="postalCode"
                placeholder="Código postal"
                maxlength="5"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="residenceDate">Fecha de Residencia</label>
              <p-calendar 
                id="residenceDate"
                formControlName="residenceDate"
                placeholder="Fecha de residencia"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="phoneNumber">Número de Teléfono</label>
              <input 
                pInputText 
                id="phoneNumber" 
                formControlName="phoneNumber"
                placeholder="Número de teléfono"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="addressType">Tipo de Domicilio</label>
              <p-dropdown 
                id="addressType"
                formControlName="addressType"
                [options]="[
                  {label: 'Propio', value: 'P'},
                  {label: 'Rentado', value: 'R'},
                  {label: 'Familiar', value: 'F'},
                  {label: 'Laboral', value: 'L'}
                ]"
                placeholder="Seleccione tipo">
              </p-dropdown>
            </div>
            
            <div class="form-field">
              <label for="settlementType">Tipo de Asentamiento</label>
              <input 
                pInputText 
                id="settlementType" 
                formControlName="settlementType"
                placeholder="Tipo de asentamiento"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="addressOrigin">Origen del Domicilio</label>
              <input 
                pInputText 
                id="addressOrigin" 
                formControlName="addressOrigin"
                placeholder="Origen del domicilio"
                class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Empleo (Solo PF) -->
    <div *ngIf="activeTab === 'employment' && entityType === 'Física'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-briefcase"></i> Empleo</h3>
          <p>Información laboral del solicitante</p>
        </div>
        <div class="card-content" formGroupName="employment">
          <div class="form-grid">
            <div class="form-field">
              <label for="companyName">Nombre de la Empresa</label>
              <input 
                pInputText 
                id="companyName" 
                formControlName="companyName"
                placeholder="Nombre de la empresa"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="position">Puesto</label>
              <input 
                pInputText 
                id="position" 
                formControlName="position"
                placeholder="Puesto de trabajo"
                class="form-control">
            </div>
            
            <div class="form-field full-width">
              <label for="address">Dirección de la Empresa</label>
              <input 
                pInputText 
                id="address" 
                formControlName="address"
                placeholder="Dirección de la empresa"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="neighborhood">Colonia/Población</label>
              <input 
                pInputText 
                id="neighborhood" 
                formControlName="neighborhood"
                placeholder="Colonia o población"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="municipality">Delegación/Municipio</label>
              <input 
                pInputText 
                id="municipality" 
                formControlName="municipality"
                placeholder="Delegación o municipio"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="city">Ciudad</label>
              <input 
                pInputText 
                id="city" 
                formControlName="city"
                placeholder="Ciudad"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="state">Estado</label>
              <input 
                pInputText 
                id="state" 
                formControlName="state"
                placeholder="Estado"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="postalCode">Código Postal</label>
              <input 
                pInputText 
                id="postalCode" 
                formControlName="postalCode"
                placeholder="Código postal"
                maxlength="5"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="phoneNumber">Teléfono</label>
              <input 
                pInputText 
                id="phoneNumber" 
                formControlName="phoneNumber"
                placeholder="Teléfono de la empresa"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="extension">Extensión</label>
              <input 
                pInputText 
                id="extension" 
                formControlName="extension"
                placeholder="Extensión telefónica"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="fax">Fax</label>
              <input 
                pInputText 
                id="fax" 
                formControlName="fax"
                placeholder="Número de fax"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="hiringDate">Fecha de Contratación</label>
              <p-calendar 
                id="hiringDate"
                formControlName="hiringDate"
                placeholder="Fecha de contratación"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="paymentFrequency">Frecuencia de Pago</label>
              <p-dropdown 
                id="paymentFrequency"
                formControlName="paymentFrequency"
                [options]="[
                  {label: 'Semanal', value: 'S'},
                  {label: 'Quincenal', value: 'Q'},
                  {label: 'Mensual', value: 'M'},
                  {label: 'Bimestral', value: 'B'}
                ]"
                placeholder="Seleccione frecuencia">
              </p-dropdown>
            </div>
            
            <div class="form-field">
              <label for="monthlyIncome">Sueldo Mensual</label>
              <p-inputNumber 
                id="monthlyIncome" 
                formControlName="monthlyIncome"
                placeholder="Sueldo mensual"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="currency">Clave de Moneda</label>
              <p-dropdown 
                id="currency"
                formControlName="currency"
                [options]="[
                  {label: 'Peso Mexicano (MXN)', value: 'MXN'},
                  {label: 'Dólar Americano (USD)', value: 'USD'},
                  {label: 'Euro (EUR)', value: 'EUR'}
                ]"
                placeholder="Seleccione moneda">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Cuentas (Solo PF) -->
    <!-- Pestaña: Detalle Cuenta (Solo PF) -->
    <div *ngIf="activeTab === 'accountDetail' && entityType === 'Física'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-credit-card"></i> Detalle de Cuenta</h3>
          <p>Información detallada de la cuenta crediticia</p>
        </div>
        <div class="card-content" formGroupName="accountDetail">
          <div class="form-grid">
            <!-- Información básica del otorgante -->
            <div class="form-field">
              <label for="grantorKey">Clave Otorgante</label>
              <input 
                pInputText 
                id="grantorKey" 
                formControlName="grantorKey"
                placeholder="Clave del otorgante"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="grantorName">Nombre Otorgante</label>
              <input 
                pInputText 
                id="grantorName" 
                formControlName="grantorName"
                placeholder="Nombre del otorgante"
                class="form-control">
            </div>
            
            <!-- Información de la cuenta -->
            <div class="form-field">
              <label for="accountNumber">Número de Cuenta</label>
              <input 
                pInputText 
                id="accountNumber" 
                formControlName="accountNumber"
                placeholder="Número de cuenta"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="previousAccountNumber">Número de Cuenta Anterior</label>
              <input 
                pInputText 
                id="previousAccountNumber" 
                formControlName="previousAccountNumber"
                placeholder="Número de cuenta anterior"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="contractType">Tipo de Contrato</label>
              <input 
                pInputText 
                id="contractType" 
                formControlName="contractType"
                placeholder="Tipo de contrato"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="accountType">Tipo de Cuenta</label>
              <input 
                pInputText 
                id="accountType" 
                formControlName="accountType"
                placeholder="Tipo de cuenta"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="accountStatus">Tipo de Responsabilidad</label>
              <input 
                pInputText 
                id="accountStatus" 
                formControlName="accountStatus"
                placeholder="Tipo de responsabilidad"
                class="form-control">
            </div>
            
            <!-- Fechas importantes -->
            <div class="form-field">
              <label for="openingDate">Fecha de Apertura</label>
              <p-calendar 
                id="openingDate"
                formControlName="openingDate"
                placeholder="Fecha de apertura"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="lastPaymentDate">Fecha Último Pago</label>
              <p-calendar 
                id="lastPaymentDate"
                formControlName="lastPaymentDate"
                placeholder="Fecha último pago"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="lastPurchaseDate">Fecha Última Compra</label>
              <p-calendar 
                id="lastPurchaseDate"
                formControlName="lastPurchaseDate"
                placeholder="Fecha última compra"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="closingDate">Fecha Cierre Cuenta</label>
              <p-calendar 
                id="closingDate"
                formControlName="closingDate"
                placeholder="Fecha cierre cuenta"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="statementDate">Fecha de Corte</label>
              <p-calendar 
                id="statementDate"
                formControlName="statementDate"
                placeholder="Fecha de corte"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <!-- Información financiera -->
            <div class="form-field">
              <label for="guarantee">Garantía</label>
              <input 
                pInputText 
                id="guarantee" 
                formControlName="guarantee"
                placeholder="Garantía"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="maxCredit">Crédito Máximo</label>
              <p-inputNumber 
                id="maxCredit" 
                formControlName="maxCredit"
                placeholder="Crédito máximo"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="currentBalance">Saldo Actual</label>
              <p-inputNumber 
                id="currentBalance" 
                formControlName="currentBalance"
                placeholder="Saldo actual"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="creditLimit">Límite de Crédito</label>
              <p-inputNumber 
                id="creditLimit" 
                formControlName="creditLimit"
                placeholder="Límite de crédito"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="pastDueBalance">Saldo Vencido</label>
              <p-inputNumber 
                id="pastDueBalance" 
                formControlName="pastDueBalance"
                placeholder="Saldo vencido"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="pastDuePaymentsNumber">Número de Pagos Vencidos</label>
              <p-inputNumber 
                id="pastDuePaymentsNumber" 
                formControlName="pastDuePaymentsNumber"
                placeholder="Número pagos vencidos"
                [min]="0"
                [max]="999"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="currentPayment">Pago Actual</label>
              <p-inputNumber 
                id="currentPayment" 
                formControlName="currentPayment"
                placeholder="Pago actual"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field full-width">
              <label for="paymentsHistory">Histórico de Pagos</label>
              <input 
                pInputText 
                id="paymentsHistory" 
                formControlName="paymentsHistory"
                placeholder="Histórico de pagos"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="observationKey">Clave de Observación</label>
              <input 
                pInputText 
                id="observationKey" 
                formControlName="observationKey"
                placeholder="Clave de observación"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="reportedPaymentsTotal">Total Pagos Reportados</label>
              <p-inputNumber 
                id="reportedPaymentsTotal" 
                formControlName="reportedPaymentsTotal"
                placeholder="Total pagos reportados"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <!-- Información de otorgante anterior -->
            <div class="form-field">
              <label for="previousGrantorKey">Clave Anterior Otorgante</label>
              <input 
                pInputText 
                id="previousGrantorKey" 
                formControlName="previousGrantorKey"
                placeholder="Clave anterior otorgante"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="previousGrantorName">Nombre Anterior Otorgante</label>
              <input 
                pInputText 
                id="previousGrantorName" 
                formControlName="previousGrantorName"
                placeholder="Nombre anterior otorgante"
                class="form-control">
            </div>
            
            <!-- Fechas adicionales -->
            <div class="form-field">
              <label for="firstDefaultDate">Fecha Primer Incumplimiento</label>
              <p-calendar 
                id="firstDefaultDate"
                formControlName="firstDefaultDate"
                placeholder="Fecha primer incumplimiento"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="pastDueEntryDate">Fecha Ingreso Cartera Vencida</label>
              <p-calendar 
                id="pastDueEntryDate"
                formControlName="pastDueEntryDate"
                placeholder="Fecha ingreso cartera vencida"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <!-- Montos adicionales -->
            <div class="form-field">
              <label for="outstandingBalance">Saldo Insoluto</label>
              <p-inputNumber 
                id="outstandingBalance" 
                formControlName="outstandingBalance"
                placeholder="Saldo insoluto"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="lastPaymentAmount">Monto Último Pago</label>
              <p-inputNumber 
                id="lastPaymentAmount" 
                formControlName="lastPaymentAmount"
                placeholder="Monto último pago"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="interestsAmount">Monto Correspondiente Intereses</label>
              <p-inputNumber 
                id="interestsAmount" 
                formControlName="interestsAmount"
                placeholder="Monto intereses"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="interestsPaymentForm">Forma Pago Actual Intereses</label>
              <input 
                pInputText 
                id="interestsPaymentForm" 
                formControlName="interestsPaymentForm"
                placeholder="Forma pago intereses"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="daysPastDue">Días de Vencimiento</label>
              <p-inputNumber 
                id="daysPastDue" 
                formControlName="daysPastDue"
                placeholder="Días vencimiento"
                [min]="0"
                [max]="9999"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="termMonths">Plazo en Meses</label>
              <p-inputNumber 
                id="termMonths" 
                formControlName="termMonths"
                placeholder="Plazo en meses"
                [min]="1"
                [max]="999"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="originationAmount">Monto Crédito Originación</label>
              <p-inputNumber 
                id="originationAmount" 
                formControlName="originationAmount"
                placeholder="Monto crédito originación"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="consumerEmail">Correo Electrónico Consumidor</label>
              <input 
                pInputText 
                id="consumerEmail" 
                formControlName="consumerEmail"
                placeholder="Correo electrónico"
                type="email"
                class="form-control">
            </div>
            
            <!-- Información CAN -->
            <div class="form-field">
              <label for="canStatus">Estatus CAN</label>
              <input 
                pInputText 
                id="canStatus" 
                formControlName="canStatus"
                placeholder="Estatus CAN"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="priorityOrderOrigin">Orden Prelación Origen</label>
              <input 
                pInputText 
                id="priorityOrderOrigin" 
                formControlName="priorityOrderOrigin"
                placeholder="Orden prelación origen"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="priorityOrderCurrent">Orden Prelación Actual</label>
              <input 
                pInputText 
                id="priorityOrderCurrent" 
                formControlName="priorityOrderCurrent"
                placeholder="Orden prelación actual"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="canOpeningDate">Fecha Apertura CAN</label>
              <p-calendar 
                id="canOpeningDate"
                formControlName="canOpeningDate"
                placeholder="Fecha apertura CAN"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
            
            <div class="form-field">
              <label for="canCancellationDate">Fecha Cancelación CAN</label>
              <p-calendar 
                id="canCancellationDate"
                formControlName="canCancellationDate"
                placeholder="Fecha cancelación CAN"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'">
              </p-calendar>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Cifras de Control (Solo PF) -->
    <div *ngIf="activeTab === 'controlFigures' && entityType === 'Física'" class="tab-content">
      <div class="content-card">
        <div class="card-header">
          <h3><i class="pi pi-calculator"></i> Cifras de Control</h3>
          <p>Resumen financiero y estadísticas de la cuenta</p>
        </div>
        <div class="card-content" formGroupName="controlFigures">
          <div class="form-grid">
            <!-- Saldos Totales -->
            <div class="form-field">
              <label for="totalCurrentBalances">Total Saldos Actuales</label>
              <p-inputNumber 
                id="totalCurrentBalances" 
                formControlName="totalCurrentBalances"
                placeholder="Total saldos actuales"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="totalPastDueBalances">Total Saldos Vencidos</label>
              <p-inputNumber 
                id="totalPastDueBalances" 
                formControlName="totalPastDueBalances"
                placeholder="Total saldos vencidos"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <!-- Elementos Reportados -->
            <div class="form-field">
              <label for="totalNameElementsReported">Total Elementos Nombre Reportados</label>
              <p-inputNumber 
                id="totalNameElementsReported" 
                formControlName="totalNameElementsReported"
                placeholder="Total elementos nombre"
                [min]="0"
                [max]="9999"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="totalAddressElementsReported">Total Elementos Domicilio Reportados</label>
              <p-inputNumber 
                id="totalAddressElementsReported" 
                formControlName="totalAddressElementsReported"
                placeholder="Total elementos domicilio"
                [min]="0"
                [max]="9999"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="totalEmploymentElementsReported">Total Elementos Empleo Reportados</label>
              <p-inputNumber 
                id="totalEmploymentElementsReported" 
                formControlName="totalEmploymentElementsReported"
                placeholder="Total elementos empleo"
                [min]="0"
                [max]="9999"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <div class="form-field">
              <label for="totalAccountElementsReported">Total Elementos Cuenta Reportados</label>
              <p-inputNumber 
                id="totalAccountElementsReported" 
                formControlName="totalAccountElementsReported"
                placeholder="Total elementos cuenta"
                [min]="0"
                [max]="9999"
                class="form-control">
              </p-inputNumber>
            </div>
            
            <!-- Información Adicional -->
            <div class="form-field">
              <label for="grantorName">Nombre Otorgante</label>
              <input 
                pInputText 
                id="grantorName" 
                formControlName="grantorName"
                placeholder="Nombre del otorgante"
                class="form-control">
            </div>
            
            <div class="form-field">
              <label for="returnAddress">Dirección de Retorno</label>
              <input 
                pInputText 
                id="returnAddress" 
                formControlName="returnAddress"
                placeholder="Dirección de retorno"
                class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pestaña: Créditos -->
    <div *ngIf="activeTab === 'credits'" class="tab-content">
      <div class="content-card">
        <div class="card-header card-header-with-action">
          <div class="header-content">
            <h3><i class="pi pi-chart-line"></i> Créditos</h3>
            <p>Historial crediticio y obligaciones financieras</p>
          </div>
          <div class="header-actions">
            <p-button 
              icon="pi pi-plus" 
              label="Agregar Crédito"
              styleClass="p-button-success p-button-outlined"
              (click)="addNewCredit()">
            </p-button>
          </div>
        </div>
        <div class="card-content">
          <!-- Estado vacío -->
          <div *ngIf="getCreditsArray().length === 0" class="empty-credits">
            <i class="pi pi-chart-line empty-icon"></i>
            <p>No se han agregado créditos</p>
            <p class="empty-description">Use el botón "Agregar Crédito" para comenzar</p>
          </div>
          
          <!-- Lista de créditos editables -->
          <div class="credits-container" formArrayName="credits">
            <div *ngFor="let creditControl of getCreditsArray().controls; let i = index" 
                 class="credit-editable-item"
                 [formGroupName]="i">
              
              <!-- Header del crédito -->
              <div class="credit-item-header">
                <div class="credit-title">
                  <h5><i class="pi pi-credit-card"></i> Crédito {{ i + 1 }}</h5>
                </div>
                <p-button 
                  icon="pi pi-trash" 
                  styleClass="p-button-danger p-button-outlined"
                  pTooltip="Eliminar crédito"
                  (click)="removeCredit(i)">
                </p-button>
              </div>
              
              <!-- Secciones del formulario de crédito -->
              <div class="credit-form-sections">
                
                <!-- Sección 1: Información Básica -->
                <div class="form-section">
                  <h6 class="section-title">📋 Información Básica</h6>
                  <div class="form-grid">
                    <div class="form-field">
                      <label for="creditType_{{i}}">Tipo de Crédito *</label>
                      <input 
                        pInputText 
                        id="creditType_{{i}}" 
                        formControlName="creditType"
                        placeholder="Tipo de crédito"
                        class="form-control"
                        [class.p-invalid]="creditControl.get('creditType')?.invalid && creditControl.get('creditType')?.touched">
                      <small *ngIf="creditControl.get('creditType')?.invalid && creditControl.get('creditType')?.touched" 
                             class="error-message">
                        El tipo de crédito es requerido
                      </small>
                    </div>

                    <div class="form-field">
                      <label for="rfc_{{i}}">RFC *</label>
                      <input 
                        pInputText 
                        id="rfc_{{i}}" 
                        formControlName="rfc"
                        placeholder="RFC de la entidad financiera"
                        class="form-control"
                        [class.p-invalid]="creditControl.get('rfc')?.invalid && creditControl.get('rfc')?.touched">
                      <small *ngIf="creditControl.get('rfc')?.invalid && creditControl.get('rfc')?.touched" 
                             class="error-message">
                        El RFC es requerido
                      </small>
                    </div>

                    <div class="form-field">
                      <label for="contractNumber_{{i}}">Número de Contrato</label>
                      <input 
                        pInputText 
                        id="contractNumber_{{i}}" 
                        formControlName="contractNumber"
                        placeholder="Número de contrato"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="creditExperiences_{{i}}">Experiencias Crediticias</label>
                      <input 
                        pInputText 
                        id="creditExperiences_{{i}}" 
                        formControlName="creditExperiences"
                        placeholder="Experiencias crediticias"
                        class="form-control">
                    </div>
                  </div>
                </div>

                <!-- Sección 2: Información Financiera -->
                <div class="form-section">
                  <h6 class="section-title">💰 Información Financiera</h6>
                  <div class="form-grid">
                    <div class="form-field">
                      <label for="initialBalance_{{i}}">Saldo Inicial</label>
                      <input 
                        pInputText 
                        id="initialBalance_{{i}}" 
                        formControlName="initialBalance"
                        placeholder="Saldo inicial"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="outstandingBalance_{{i}}">Saldo Insoluto</label>
                      <input 
                        pInputText 
                        id="outstandingBalance_{{i}}" 
                        formControlName="outstandingBalance"
                        placeholder="Saldo pendiente"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="currency_{{i}}">Moneda</label>
                      <input 
                        pInputText 
                        id="currency_{{i}}" 
                        formControlName="currency"
                        placeholder="MXN, USD, etc."
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="maxCreditUsed_{{i}}">Máximo Crédito Utilizado</label>
                      <input 
                        pInputText 
                        id="maxCreditUsed_{{i}}" 
                        formControlName="maxCreditUsed"
                        placeholder="Máximo crédito utilizado"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="observationKey_{{i}}">Clave de Observación</label>
                      <input 
                        pInputText 
                        id="observationKey_{{i}}" 
                        formControlName="observationKey"
                        placeholder="Clave de observación"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="paymentAmount_{{i}}">Monto de Pago</label>
                      <input 
                        pInputText 
                        id="paymentAmount_{{i}}" 
                        formControlName="paymentAmount"
                        placeholder="Pago periódico"
                        class="form-control">
                    </div>
                  </div>
                </div>

                <!-- Sección 3: Fechas Importantes -->
                <div class="form-section">
                  <h6 class="section-title">📅 Fechas Importantes</h6>
                  <div class="form-grid">
                    <div class="form-field">
                      <label for="openingDate_{{i}}">Fecha de Apertura</label>
                      <p-calendar
                        id="openingDate_{{i}}"
                        formControlName="openingDate"
                        placeholder="Fecha de apertura"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'">
                      </p-calendar>
                    </div>

                    <div class="form-field">
                      <label for="settlementDate_{{i}}">Fecha de Liquidación</label>
                      <p-calendar
                        id="settlementDate_{{i}}"
                        formControlName="settlementDate"
                        placeholder="Fecha de liquidación"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'">
                      </p-calendar>
                    </div>

                    <div class="form-field">
                      <label for="lastPaymentDate_{{i}}">Último Pago</label>
                      <p-calendar
                        id="lastPaymentDate_{{i}}"
                        formControlName="lastPaymentDate"
                        placeholder="Fecha último pago"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'">
                      </p-calendar>
                    </div>

                    <div class="form-field">
                      <label for="firstDefaultDate_{{i}}">Fecha de Primer Incumplimiento</label>
                      <p-calendar
                        id="firstDefaultDate_{{i}}"
                        formControlName="firstDefaultDate"
                        placeholder="Fecha primer incumplimiento"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'">
                      </p-calendar>
                    </div>
                  </div>
                </div>

                <!-- Sección 4: Información Adicional -->
                <div class="form-section">
                  <h6 class="section-title">📝 Información Adicional</h6>
                  <div class="form-grid">
                    <div class="form-field">
                      <label for="paymentFrequency_{{i}}">Frecuencia de Pago</label>
                      <input 
                        pInputText 
                        id="paymentFrequency_{{i}}" 
                        formControlName="paymentFrequency"
                        placeholder="Mensual, Quincenal, etc."
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="paymentsNumber_{{i}}">Número de Pagos</label>
                      <input 
                        pInputText 
                        id="paymentsNumber_{{i}}" 
                        formControlName="paymentsNumber"
                        placeholder="Total de pagos"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="termMonths_{{i}}">Plazo en Meses</label>
                      <input 
                        pInputText 
                        id="termMonths_{{i}}" 
                        formControlName="termMonths"
                        placeholder="Plazo en meses"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="special_{{i}}">Mención Especial</label>
                      <input 
                        pInputText 
                        id="special_{{i}}" 
                        formControlName="special"
                        placeholder="Observaciones especiales"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="previousContractNumber_{{i}}">Número de Contrato Anterior</label>
                      <input 
                        pInputText 
                        id="previousContractNumber_{{i}}" 
                        formControlName="previousContractNumber"
                        placeholder="Contrato anterior"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="restructuringDate_{{i}}">Fecha de Reestructuración</label>
                      <p-calendar
                        id="restructuringDate_{{i}}"
                        formControlName="restructuringDate"
                        placeholder="Fecha de reestructuración"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'">
                      </p-calendar>
                    </div>

                    <div class="form-field">
                      <label for="cashPayment_{{i}}">Pago en Efectivo</label>
                      <input 
                        pInputText 
                        id="cashPayment_{{i}}" 
                        formControlName="cashPayment"
                        placeholder="Pago en efectivo"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="writeOff_{{i}}">Castigo</label>
                      <input 
                        pInputText 
                        id="writeOff_{{i}}" 
                        formControlName="writeOff"
                        placeholder="Castigo"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="dation_{{i}}">Dación en Pago</label>
                      <input 
                        pInputText 
                        id="dation_{{i}}" 
                        formControlName="dation"
                        placeholder="Dación en pago"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="lossOrCharge_{{i}}">Pérdida o Cargo</label>
                      <input 
                        pInputText 
                        id="lossOrCharge_{{i}}" 
                        formControlName="lossOrCharge"
                        placeholder="Pérdida o cargo"
                        class="form-control">
                    </div>

                    <div class="form-field">
                      <label for="pastDuePortfolioEntryDate_{{i}}">Fecha de Entrada a Cartera Vencida</label>
                      <p-calendar
                        id="pastDuePortfolioEntryDate_{{i}}"
                        formControlName="pastDuePortfolioEntryDate"
                        placeholder="Fecha entrada cartera vencida"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'">
                      </p-calendar>
                    </div>
                  </div>
                </div>

                <!-- Sección 5: Detalles del Crédito (FormArray anidado) -->
                <div class="form-section">
                  <div class="section-header-with-action">
                    <h6 class="section-title">🔍 Detalles del Crédito</h6>
                    <p-button 
                      icon="pi pi-plus" 
                      label="Agregar Detalle"
                      styleClass="p-button-help p-button-outlined p-button-sm"
                      (click)="addCreditDetail(i)">
                    </p-button>
                  </div>
                  
                  <div formArrayName="details">
                    <div *ngFor="let detailControl of getCreditDetailsArray(i).controls; let j = index" 
                         class="credit-detail-item"
                         [formGroupName]="j">
                      
                      <div class="detail-header">
                        <span class="detail-number">Detalle {{ j + 1 }}</span>
                        <p-button 
                          icon="pi pi-trash" 
                          styleClass="p-button-danger p-button-outlined p-button-sm"
                          pTooltip="Eliminar detalle"
                          (click)="removeCreditDetail(i, j)">
                        </p-button>
                      </div>
                      
                      <div class="form-grid">
                        <div class="form-field">
                          <label for="rfc_{{i}}_{{j}}">RFC</label>
                          <input 
                            pInputText 
                            id="rfc_{{i}}_{{j}}" 
                            formControlName="rfc"
                            placeholder="RFC"
                            class="form-control">
                        </div>

                        <div class="form-field">
                          <label for="contractNumber_{{i}}_{{j}}">Número de Contrato</label>
                          <input 
                            pInputText 
                            id="contractNumber_{{i}}_{{j}}" 
                            formControlName="contractNumber"
                            placeholder="Número de contrato"
                            class="form-control">
                        </div>

                        <div class="form-field">
                          <label for="overdueDays_{{i}}_{{j}}">Días de Atraso</label>
                          <input 
                            pInputText 
                            id="overdueDays_{{i}}_{{j}}" 
                            formControlName="overdueDays"
                            placeholder="Días de atraso"
                            class="form-control">
                        </div>

                        <div class="form-field">
                          <label for="amount_{{i}}_{{j}}">Monto</label>
                          <input 
                            pInputText 
                            id="amount_{{i}}_{{j}}" 
                            formControlName="amount"
                            placeholder="Monto del detalle"
                            class="form-control">
                        </div>

                        <div class="form-field">
                          <label for="interests_{{i}}_{{j}}">Intereses</label>
                          <input 
                            pInputText 
                            id="interests_{{i}}_{{j}}" 
                            formControlName="interests"
                            placeholder="Intereses"
                            class="form-control">
                        </div>
                      </div>
                    </div>
                    
                    <div *ngIf="getCreditDetailsArray(i).length === 0" class="empty-details">
                      <p>No hay detalles agregados para este crédito</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer del Modal -->
  <ng-template pTemplate="footer">
    <div class="modal-footer">      
      <div class="action-buttons">
        <p-button 
          label="Cancelar" 
          (onClick)="onModalHide()"
          styleClass="p-button-text">
        </p-button>
        
        <p-button 
          icon="pi pi-save" 
          label="Guardar"
          (onClick)="onSaveData()"
          [loading]="isLoading"
          [disabled]="isLoading"
          styleClass="p-button-primary">
        </p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
